<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-main :style="`height:${dispH - 145}px;`" class="border-normal">
        <VideoPlayer
          v-if="!isHugeMapVisible"
          :zoom="zoom"
          :src="videoSrc"
          :startTime="calcstarttime"
          :realTotalTime="totaltime"
          :usefulTime="usefultime"
        />
        <div v-if="isHugeMapVisible" class="wrapper-full">
          <NibutMap
            :dispW="dispW - 862"
            :dispH="dispH - 170"
            :mapData="mapData"
            :outputStyle="outputStyle"
            :usefulTime="usefultime"
          />
        </div>
      </el-main>
      <el-aside width="570px" :style="`height:${dispH - 100}px;padding-bottom:5px`">
        <div class="aside-container">
          <div style="width: 570px; height: 500px" @click="showHugeMap">
            <NibutMap
              v-if="mapVisible"
              :dispW="570"
              :dispH="474"
              :mapData="mapData"
              :usefulTime="usefultime"
            />
          </div>
          <div :style="`height:${dispH - 100 - 80 - 500 - 80}px;`">
            <TrendChart
              :dispW="550"
              :gridRight="40"
              :dispH="dispH - 100 - 80 - 500 - 96"
              :trendData="caculateTrendData"
              :xRange="{ min: 0, max: 21 }"
              :yRange="{ min: 0, max: 100 }"
              :titleVisible="false"
              :title="$t('langcfg.txtNibutTrendChart')"
            />
          </div>
          <div style="width: 474px">
            <el-form label-position="left" style="margin-top: 14px">
              <el-form-item :label="$t('langcfg.txtFirstRuptureTime') + ':'">
                <span class="baseFontSize">{{ FIRSTRUPTURETIME }}</span>
              </el-form-item>
              <el-form-item :label="$t('langcfg.txtAverageRuptureTime') + ':'">
                <span class="baseFontSize">{{ AVGRUPTRURETIME }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import VideoPlayer from "./basic/VideoPlayer";
import TrendChart from "./basic/TrendChart";
import NibutMap from "./basic/NibutMap";
import { objectCopy, getImageUrl, isDefined } from "../../shared/utils";
import EVENTS from "../../bus";
export default {
  name: "Nibut",
  mixins: [Size, SubPageSize],
  data() {
    return {
      zoom: 1.5,
      videoSrc: "",
      trendData: {
        tearArrayX: [],
        tearArrayY: []
      },
      isHugeMapVisible: false,
      mapVisible: false,
      mapData: [],
      mycurrentrecord: {},
      photos: [],
      calcstarttime: -1,
      totaltime: -2,
      usefultime: 0,
      firstrupturetime: "",
      avgRuptruretime: "",
      caculateTrendData: [],
      outputStyle: {
        asideStyle: "margin-right:28px",
        canvasStyle: "padding-left:80px"
      }
    };
  },
  props: {
    record: {
      type: Object
    },
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  watch: {
    currentEye(newType) {
      this.currentEye = newType;

      this.isHugeMapVisible = false;
      this.mapVisible = false;
      this.ifOS(this.record);
    },
    record: {
      handler(newRecord) {
        if (newRecord && newRecord.content) {
          this.ifOS(newRecord);
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.ifOS(this.record);
    let typeface = document.getElementsByClassName("el-form-item__label");
    if (window.settings.language === "de") {
      typeface[0].style = "font-size: 27px";
      typeface[1].style = "font-size: 27px";
    } else {
      typeface[0].style = "font-size: 30px";
      typeface[1].style = "font-size: 30px";
    }
    this.$bus.$emit(EVENTS.uploadingThirdyParty, "nibut");
  },
  updated() {
    let typeface = document.getElementsByClassName("el-form-item__label");
    if (window.settings.language === "de") {
      typeface[0].style = "font-size: 27px";
      typeface[1].style = "font-size: 27px";
    } else {
      typeface[0].style = "font-size: 30px";
      typeface[1].style = "font-size: 30px";
    }
  },
  components: {
    VideoPlayer,
    TrendChart,
    NibutMap
  },
  methods: {
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    ifOS(record) {
      this.mycurrentrecord = objectCopy(record);

      if (this.mycurrentrecord.content[`data${this.currentEye}`].nibut) {
        const { nibut } = this.mycurrentrecord.content[`data${this.currentEye}`];
        const { photos } = nibut;
        this.photos = photos;
        const { filename } = this.photos[0];
        this.videoSrc = this.getImageURL(filename);
        const {
          rupturetimes,
          totaltime,
          calcstarttime,
          usefultime,
          firstrupturetime,
          avgruptruretime
        } = nibut;
        this.mapData = rupturetimes === -1 ? [] : rupturetimes;
        this.trendMapData = rupturetimes;
        // if (this.mapData) {
        //   this.handleRupturetimes() // 组装二维数组
        // }
        this.mapVisible = true;
        // toFixed()转化结果为String
        this.totaltime = isDefined(totaltime) ? Number(totaltime.toFixed(2)) : 0;
        this.calcstarttime = isDefined(calcstarttime) ? Number(calcstarttime.toFixed(2)) : 0;
        this.usefultime = isDefined(calcstarttime) ? Number(usefultime) : 0;
        this.firstrupturetime = firstrupturetime;
        this.avgRuptruretime = avgruptruretime;
        // 对trendData做处理
        if (rupturetimes) {
          this.RUPTURETIMES();
        }
      }
    },
    TrendData() {
      let tearArrayYNeed = [];
      let tearArrayXNeed = [];
      let endAxias = this.usefultime + this.calcstarttime;
      for (let i = 0; i < this.trendData.tearArrayY.length; i++) {
        if (this.trendData.tearArrayY[i] <= this.usefultime * 10) {
          tearArrayYNeed.push(this.trendData.tearArrayY[i]);
        }
      }
      // tearArrayXNeed = [...this.trendData.tearArrayX, this.usefultime]
      tearArrayXNeed = [...this.trendData.tearArrayX, endAxias];

      tearArrayYNeed.push(tearArrayYNeed[tearArrayYNeed.length - 1]);
      this.caculateTrendData = tearArrayXNeed.map((key, value) => [key, tearArrayYNeed[value]]);

      for (let j = 0; j < this.caculateTrendData.length; j++) {
        if (this.caculateTrendData[j][1] === undefined) {
          this.caculateTrendData[j][1] = this.usefultime;
        }
      }
      // let new_caculateTrendData = this.caculateTrendData.filter(item => item[1] === undefined)
    },
    // 拼接src
    getImageURL(filename) {
      return getImageUrl(filename, window.server, window.token);
    },
    sequence(a, b) {
      if (a > b) return 1;
      else if (a < b) return -1;
      else return 0;
    },
    CalculateTheNumberOfFractures(mapData, i) {
      let num = 0;
      mapData.map((value) => {
        if (value !== -1 && value * 10 < i) {
          num++;
        }
      });
      return num / 4;
    },
    RUPTURETIMES() {
      let mapData = this.mapData.concat();
      let [x, y] = [[], []];
      for (let i = 0; i < 210; i++) {
        if (i < Math.floor(this.usefultime * 10)) {
          x.push(i / 10);
          y.push(this.CalculateTheNumberOfFractures(mapData, i));
        }
      }
      this.trendData.tearArrayX = x;
      this.trendData.tearArrayY = y;
      this.TrendData();
    }
  },
  computed: {
    FIRSTRUPTURETIME() {
      if (this.firstrupturetime) {
        if (this.firstrupturetime === -1) {
          return ">0s";
        } else if (this.firstrupturetime === 10000) {
          return this.usefultime
            ? `>${Number(this.usefultime.toFixed(2))}s`
            : `>${Number(this.totaltime.toFixed(2))}s`;
        } else {
          return `${this.firstrupturetime.toFixed(2)}s`;
        }
      } else if (this.firstrupturetime === 0) {
        // return `${this.firstrupturetime}s`
        return `0.04s`;
      } else {
        return "--";
      }
    },
    AVGRUPTRURETIME() {
      if (this.avgRuptruretime) {
        if (this.avgRuptruretime === -1) {
          return ">0s";
        } else if (this.avgRuptruretime === 10000) {
          return this.usefultime
            ? `>${Number(this.usefultime.toFixed(2))}s`
            : `>${Number(this.totaltime.toFixed(2))}s`;
        } else {
          return `${this.avgRuptruretime.toFixed(2)}s`;
        }
      } else if (this.avgRuptruretime === 0) {
        return `0.04s`;
      } else {
        return "--";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
.baseFontSize {
  font-size: 30px;
  float: right;
  line-height: 50px;
}
/deep/ .el-form-item {
  line-height: 50px;
  height: 50px;
}
/deep/.el-form-item__label {
  margin-left: 5px;
  font-size: 30px;
  line-height: 50px;
}
/deep/.el-form-item__content {
  line-height: 65px;
  height: 65px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/Nibut.vue